import React, { useEffect, useState } from 'react';
import { InputNumber } from 'antd';

const CalendarDays = props => {
  const { t, value, min, disabled, onChange } = props;
  const [count, setCount] = useState(value);

  useEffect(() => {
    setCount(value);
  }, [value]);

  const handleChange = value => {
    setCount(value);
    onChange(value);
  };

  const handleBlur = e => {
    if (e.target.value === '') {
      setCount(min);
      onChange(min);
    }
  };

  return (
    <div className="calendar-days__wrapper">
      <InputNumber
        className="calendar-days__input"
        min={min}
        precision={0}
        value={count}
        disabled={disabled}
        onChange={handleChange}
        onBlur={handleBlur}
      />
      <div className="calendar-days__label">
        {t('cms:cms.properties.edit.detail.cancellation_period.calendar_days')}
      </div>
    </div>
  );
};

export default CalendarDays;
